import React, { Component } from 'react';
import { Button, Checkbox, Col, Form, Input, Row, Select, Divider } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { BANK_NAMES } from '../../../constants/bank.js.erb';

const { Option } = Select;

class CreditInfoAttributes extends Component {
  render () {
    return (
      <>
        <Col span={24}>
          <Divider orientation="left">Información de créditos</Divider>
        </Col>
        <Form.List name="creditInfosAttributes">
          {(creditInfosAttributes, { add, remove }) => (
            <Col span={24}>
              {creditInfosAttributes.map((field, index) => (
                <Row key={`credit-info-attribute-${field.key}`} gutter={4} align="middle">
                  <Form.Item name={[index, 'id']} hidden>
                    <Input/>
                  </Form.Item>
                  <Col span={6}>
                    <Form.Item label="Institución" name={[index, 'bankName']}>
                      <Select placeholder="Seleccione Banco">
                        {
                          BANK_NAMES.map((bank) => (
                            <Option value={bank} key={`credit-${index}-${bank}`}>{bank}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Nombre ejecutivo" name={[index, 'agentName']}>
                      <Input/>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Teléfono" name={[index, 'agentPhoneNumber']}>
                      <Input/>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Email" name={[index, 'agentEmail']}>
                      <Input/>
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item label="Firmado" name={[index, 'signed']} valuePropName="checked">
                      <Checkbox/>
                    </Form.Item>
                  </Col>
                  <Col span={1} className="d-flex flex-row align-items-center">
                    <MinusCircleOutlined className="dynamic-delete-button" onClick={() => remove(field.name)}/>
                  </Col>
                </Row>
              ))}
              <Button type="dashed" onClick={() => add({ signed: false })} className="mb-1">
                <PlusOutlined/> Agregar crédito
              </Button>
            </Col>
          )}
        </Form.List>
      </>
    );
  }
}

export default CreditInfoAttributes;
